import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { useNotification } from "app/NotificationProvider";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { StyledInputContainer } from "features/StyledInputContainer";
import {
  FieldPreparationEvent,
  updateFieldPreparationEvent,
  useAppDispatch,
} from "model";
import { Dispatch, SetStateAction } from "react";
import EnterFieldPreparationEvent from "./EnterFieldPreparationEvent";
import {
  convertFromFormInput,
  FieldPreparationEventFormData,
} from "./FieldPreparationEventFormData";

export default function UpdateFieldPreparationEvent({
  fieldPreparationEvent,
  dialogOpen,
  setDialogOpen,
}: {
  fieldPreparationEvent: FieldPreparationEvent;
  dialogOpen: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const dispatch = useAppDispatch();
  const { notify } = useNotification();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    setDialogOpen(false);
    mixpanel.track("Update fieldPreparation event cancelled");
  };

  async function handleSave(
    fieldPreparationEventFormData: FieldPreparationEventFormData
  ) {
    const convertedFieldPreparationEvent = convertFromFormInput(
      fieldPreparationEventFormData
    );
    await dispatch(
      updateFieldPreparationEvent({
        ...convertedFieldPreparationEvent,
        guid: fieldPreparationEvent.guid,
      })
    );
    notify(t("updateFieldPreparationEvent.add.success"));
    mixpanel.track("FieldPreparation event updated");
    handleClose();
  }
  return (
    <Dialog
      fullScreen={isMobile}
      maxWidth="md"
      disableEscapeKeyDown
      open={dialogOpen}
      onClose={handleClose}
    >
      <StyledInputContainer isMobile={isMobile}>
        {
          <EnterFieldPreparationEvent
            fieldPreparationEvent={fieldPreparationEvent}
            handleSave={handleSave}
            handleClose={() => {
              handleClose();
            }}
            fieldSelectDisabled={false}
          />
        }
      </StyledInputContainer>
    </Dialog>
  );
}
